    
import { Component, Prop, Vue } from 'vue-property-decorator';
import { namespace } from "vuex-class";

import "@/store/modules/common";
import { locationsInfoType } from '@/types/Common';
const commonState = namespace("Common");

import ParentingAfterSeparationInstructions from "./postFilingSteps/ParentingAfterSeparationInstructions.vue";
import ProofOfServiceInstructions from "./postFilingSteps/ProofOfServiceInstructions.vue";
import ArrangeForServiceFlmInstructions from "./postFilingSteps/ArrangeForServiceFlmInstructions.vue";
import GiveFiledCopyOfNoticeErpInstructions from "./postFilingSteps/GiveFiledCopyOfNoticeErpInstructions.vue";
import CompleteEarlyResolutionProcessErpInstructions from "./postFilingSteps/CompleteEarlyResolutionProcessErpInstructions.vue"
import ArrangeForServicePoInstructions from "./postFilingSteps/ArrangeForServicePoInstructions.vue";
import ReviewStampedDocumentPoInstructions from "./postFilingSteps/ReviewStampedDocumentPoInstructions.vue";
import CompleteProvideForRegistryPoInstructions from "./postFilingSteps/CompleteProvideForRegistryPoInstructions.vue";
import AttendCourtAppearanceInstructions from "./postFilingSteps/AttendCourtAppearanceInstructions.vue";

import ArrangeForServiceCmPpmRelocEnfrcInstructions from "./postFilingSteps/ArrangeForServiceCmPpmRelocEnfrcInstructions.vue"
import WaitForJudgeToReview from "./postFilingSteps/WaitForJudgeToReview.vue"
import ServeCopyOfOrderOnOtherParty from "./postFilingSteps/ServeCopyOfOrderOnOtherParty.vue"
import {whichCaseMgmtForm} from "@/components/steps/caseMgmt/reviewCM/RequiredForm"

import ArrangeForServiceWrInstructions from "./postFilingSteps/ArrangeForServiceWrInstructions.vue"

import ScheduleFamilyManagementConference from "./postFilingSteps/ScheduleFamilyManagementConference.vue"
import AttendFamilyManagementConference from "./postFilingSteps/AttendFamilyManagementConference.vue"

@Component({
    components:{        
        ArrangeForServiceFlmInstructions,
        ProofOfServiceInstructions,
        ParentingAfterSeparationInstructions,
        ArrangeForServicePoInstructions,
        ReviewStampedDocumentPoInstructions,
        CompleteProvideForRegistryPoInstructions,
        AttendCourtAppearanceInstructions,
        GiveFiledCopyOfNoticeErpInstructions,
        CompleteEarlyResolutionProcessErpInstructions,
        ArrangeForServiceCmPpmRelocEnfrcInstructions,
        WaitForJudgeToReview,
        ServeCopyOfOrderOnOtherParty,
        ArrangeForServiceWrInstructions,
        ScheduleFamilyManagementConference,
        AttendFamilyManagementConference
    }
})
export default class Instructions extends Vue {

    @Prop({required: true})
    applicationId!: string;

    @commonState.State
    public locationsInfo!: locationsInfoType[];

    applicationLocationInfo = {} as locationsInfoType;
    listOfselectedForms: string[] = [];
    listOfselectedReplyForms: string[] = [];
    urgentPO = false;
    earlyResolution = false;

    conditionArray: boolean[] = [];
    instructionsStepArray: number[] = [];

    dataReady = false;
    includeParentingAfterSeparationStep = false;
    includesFlm = false;
    includesPo = false;
    includesPpm = false;
    includesCm = false;
    includesReloc = false;
    includesEnfrc = false;
    includeCmWithoutNotice = false;
    includeCmWithNotice = false;
    includesWr = false;
    includesRflm = false;
    applicationByConsent = false;

    error = ''

    mounted(){
        this.dataReady = false;
        this.getApplicationInfo(this.applicationId);        
    } 

    public getApplicationInfo(applicationId) { 

        this.includeParentingAfterSeparationStep = false;
        this.includesFlm = false; 
        this.earlyResolution = false;
        this.includesPo = false;
        this.urgentPO = false;     
    
        this.$http.get('/app/'+ applicationId + '/')
        .then((response) => {

            const applicationData = response.data;
            console.log(applicationData)  
           
            const stepGETSTART = this.getStepResultByName(applicationData, 'GETSTART');
            const stepPO = this.getStepResultByName(applicationData, 'PO');
            const stepCOMM = this.getStepResultByName(applicationData, 'COMMON');
            const stepCM = this.getStepResultByName(applicationData, 'CM');

            if (stepGETSTART?.selectedActivity.includes('applyForOrder') && stepGETSTART?.selectedForms){
                this.listOfselectedForms = stepGETSTART.selectedForms;
            }

            this.includesFlm = this.listOfselectedForms.includes('familyLawMatter'); 
            this.includesPo = this.listOfselectedForms.includes('protectionOrder');
            this.includesPpm = this.listOfselectedForms.includes('priorityParenting'); 
            this.includesCm = this.listOfselectedForms.includes('caseMgmt');
            this.includesReloc = this.listOfselectedForms.includes('childReloc'); 
            this.includesEnfrc = this.listOfselectedForms.includes('agreementEnfrc');
            
            if(this.includesPo && stepPO?.urgencySurvey?.data?.PORNoNotice ){
                this.urgentPO = stepPO.urgencySurvey.data.PORNoNotice == "y";
            } else {
                this.urgentPO = false;
            }

            const applicationLocationName = applicationData.applicationLocation?applicationData.applicationLocation:'';

            if (this.includesFlm 
                    && Vue.filter('includedInRegistries')(applicationLocationName, 'early-resolutions')
                    && (stepCOMM?.filingLocationSurvey?.data?.MetEarlyResolutionRequirements == 'n')){
                this.earlyResolution = true;
            } else {
                this.earlyResolution = false;
            }

            
            this.applicationLocationInfo = this.locationsInfo.filter(locationInfo => locationInfo.name == applicationLocationName)[0];
            this.includeParentingAfterSeparationStep = this.includesFlm && (   
                   Vue.filter('includedInRegistries')(applicationLocationName, 'early-resolutions')
                || Vue.filter('includedInRegistries')(applicationLocationName, 'parenting-education')
                || Vue.filter('includedInRegistries')(applicationLocationName, 'family-justice')
                );

            if (stepGETSTART?.selectedActivity.includes('replyToApplication') && stepGETSTART?.selectedReplyForms){
                this.listOfselectedReplyForms = stepGETSTART.selectedReplyForms;
            }

            this.includesWr = this.listOfselectedReplyForms.includes('writtenResponse');
            this.includesRflm = this.listOfselectedReplyForms.includes('replyFlm');


            // //______TEMPORARY Check_________
            // //______________________________
            // this.includeParentingAfterSeparationStep = false;
            // this.includesFlm = false; 
            // this.earlyResolution = false;
            // this.includesPo = false;
            // this.urgentPO = false;
            
            // this.includesCm = false;
            // this.includeCmWithoutNotice = false;
            // this.includesPpm = false;
            // this.includesReloc = false;
            // this.includesEnfrc = false;

            // this.includesWr = false;
            // this.includesRflm = false;

            // console.error("_new set__")
            // console.log('Separation',this.includeParentingAfterSeparationStep);
            // console.log('FLM',this.includesFlm); 
            // console.log('earlyResolu',this.earlyResolution);
            // console.log('PO',this.includesPo);
            // console.log('urgentPO',this.urgentPO);

            // console.log('PPM',this.includesPpm)
            // console.log('CM',this.includesCm)
            // console.log('CMwithout',this.includeCmWithoutNotice)
            // console.log('RELOC',this.includesReloc)
            // console.log('ENFRC',this.includesEnfrc)
            // //______________________________ 
            
            const CMforms =  this.includesCm && stepCM? whichCaseMgmtForm(stepCM) : [];
            this.includeCmWithNotice = CMforms?.includes("P10");
            this.includeCmWithoutNotice = CMforms?.includes("P11");
            this.applicationByConsent = this.includesCm && this.includeCmWithNotice;

            this.getConditionsSteps();
            Vue.nextTick(()=> this.dataReady = true);
            

        }, err => {
            this.error = err;        
        });
    }

    public getConditionsSteps(){

        //parenting-after-separation-instructions 
        this.conditionArray[0] = this.includeParentingAfterSeparationStep;
        this.instructionsStepArray[0] = 0;     

        //arrange-for-service-flm-instructions 
        this.conditionArray[1] = this.includesFlm && !this.earlyResolution ;
        this.instructionsStepArray[1] = 0;

        //give-filed-copy-of-notice-erp-instructions
        this.conditionArray[2] =  this.includesFlm && this.earlyResolution;
        this.instructionsStepArray[2] = 0; 

        //complete-early-resolution-process-erp-instructions        
        this.conditionArray[3] =  this.includesFlm && this.earlyResolution;
        this.instructionsStepArray[3] = 0; 
               
        //arrange-for-service-po-instructions 
        this.conditionArray[4] =  this.includesPo && !this.urgentPO;
        this.instructionsStepArray[4] = 0;

        //review-stamped-document-po-instructions 
        this.conditionArray[5] = this.includesPo && this.urgentPO;
        this.instructionsStepArray[5] = 0;

        //complete-provide-for-registry-po-instructions 
        this.conditionArray[6] = this.includesPo && this.urgentPO;
        this.instructionsStepArray[6] = 0;        

        //arrange-for-service-cm-instructions
        this.conditionArray[7] = this.includesCm && this.includeCmWithNotice;
        this.instructionsStepArray[7] = 0;

        //arrange-for-service-cm-without-notice-instructions
        //wait-for-judge-to-review
            this.conditionArray[8] = this.includesCm && this.includeCmWithoutNotice;
            this.instructionsStepArray[8] = 0;
        //serve-copy-of-order-on-other-party
            this.conditionArray[9] = this.includesCm && this.includeCmWithoutNotice;
            this.instructionsStepArray[9] = 0;

        //arrange-for-service-ppm-instructions
        this.conditionArray[10] = this.includesPpm ;
        this.instructionsStepArray[10] = 0;

        //arrange-for-service-reloc-instructions
        this.conditionArray[11] = this.includesReloc ;
        this.instructionsStepArray[11] = 0;

        //arrange-for-service-enfrc-instructions
        this.conditionArray[12] = this.includesEnfrc ;
        this.instructionsStepArray[12] = 0;

        //arrange-for-service-wr-instructions
        this.conditionArray[13] = this.includesWr ;
        this.instructionsStepArray[13] = 0;

        //proof-of-service-instructions
        this.conditionArray[14] =   (this.includesFlm && !this.includesPo) || 
                                    (this.includesPo && !this.urgentPO)    ||
                                    (this.includesCm && this.includeCmWithNotice) ||
                                    this.includesPpm ||
                                    this.includesReloc ||
                                    this.includesEnfrc || 
                                    this.includesWr;
                                    
        this.instructionsStepArray[14] = 0;
        
        //attend-court-appearance-instructions
        this.conditionArray[15] = this.includesPo ||
                                 (this.includesCm && this.includeCmWithNotice) ||
                                  this.includesPpm ||
                                  this.includesReloc ||
                                  this.includesEnfrc || 
                                  this.includesWr; 
        this.instructionsStepArray[15] = 0;
        


        //schedule-family-management-conference
        this.conditionArray[16] = this.includesRflm ;
        this.instructionsStepArray[16] = 0;

        //attend-family-management-conference
        this.conditionArray[17] = this.includesRflm ;
        this.instructionsStepArray[17] = 0;




        //================Adjust Step Numbers===========
        let stepNum = 1;
        for(let i =0; i<this.conditionArray.length; i++){
            if(this.conditionArray[i]){
                this.instructionsStepArray[i] = stepNum;
                stepNum++;
            }
        }


    }
    
    public getStepResultByName(applicationData, stepName){
        if(applicationData?.steps){
            const steps = applicationData.steps.filter(step => step.name == stepName);
            if(steps.length == 1) return steps[0].result
        }
        return {}
    }
                
}
